export default `<svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 7.87879L9 1L0.999999 7.87879" stroke="#141A77"/>
</svg>`
